module.exports = __webpack_public_path__ + "img/sikbom.3416f006.png";